import React from 'react';
import { Accordion } from 'semantic-ui-react';
import { hasMinimumLength } from '@/utils/resultsHelper';
import SystemFlagWrapper from '@/components/SystemFlagWrapper';
import AccordionHeader from '@/components/accordion/AccordionHeader';
import RequestDestinationList from './RequestDestinationList';
import RequestWorspaceIconMessage from '../workspaces/components/RequestWorspaceIconMessage';
import { requestWorkspaceIcon } from '../workspaces/helper';
import RequestWorkspaceStatus from '../workspaces/components/RequestWorkspaceStatus';
import Selectors from '../hooks/selectors';
import Fetch from '../workspaces/hooks/fetch';

const RequestDestinationAccordion = ({
  active,
  category,
  code,
  index,
  onClick,
}) => {
  const { request, withLink } = Selectors.useRequestDestinationAccordion({ category, code });
  const workspaceCreated = hasMinimumLength(request.workspace_inbox_url);
  Fetch.useFetchRequestWorkspace({ active, workspaceCreated, ...request });

  return (
    <>
      <AccordionHeader active={active} index={index} onClick={onClick} headerId="request.destination.title">
        {!workspaceCreated && (
        <div className="float-r">
          <SystemFlagWrapper className={requestWorkspaceIcon(request).color}>
            <RequestWorspaceIconMessage request={request} />
          </SystemFlagWrapper>
        </div>
        )}
      </AccordionHeader>
      {active && (
      <>
        <RequestWorkspaceStatus request={request} />
        <Accordion.Content active={active}>
          <RequestDestinationList category={category} request={request} withLink={withLink} />
        </Accordion.Content>
      </>
      )}
    </>
  );
};

export default RequestDestinationAccordion;
